const getCorrectDeclination = (num: number) => {
  let n = Math.abs(num);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return `${num} человек уже прошли курс`;
  }
  n %= 10;
  if (n === 1) {
    return `${num} человек уже прошел курс`;
  }
  if (n >= 2 && n <= 4) {
    return `${num} человека уже прошли курс`;
  }
  return `${num} человек уже прошли курс`;
}

export { getCorrectDeclination }
